<template>
  <div>
    <loading-spinner v-if="loading" />
    <template v-else>
      <h3 v-label-key="'EMAIL_TEMPLATES'" />
      <p>
        Manage the email templates for a distributor.
      </p>
      <p>
        It's important to include the custom variable texts as they will be
        replaced later.
      </p>
      <p>
        A distributor must have their custom domain set up. When adding a new
        user via the custom domain dashboard, or when users access the forgot
        password link via the custom domain, the custom email templates will be
        used.
      </p>
      <p>
        Your custom domain is: <code>{{ distributor.domain_name }}</code>
      </p>
      <hr />
      <h4>Sender Email Address</h4>
      <p>
        Any email address that is not <code>@gokaizen.com</code> will need to be
        manually approved on Amazon Simple Email Service (SES).
      </p>
      <b-form-group label="Sender Email">
        <b-form-input v-model="distributorEmail" type="email" />
      </b-form-group>
      <b-button variant="primary" @click="saveDistributorEmail"
        ><span>{{ getLabel('SAVE') }}</span></b-button
      >

      <div v-for="(value, key) in emailTemplates" :key="key">
        <hr />
        <email-template
          :type="key"
          :templates="distributorTemplates"
          @save="saveTemplate"
        />
      </div>
    </template>
  </div>
</template>
<script>
import LoadingSpinner from '@/components/LoadingSpinner';
import EmailTemplate from '@/components/EmailTemplate';

import $api from '@/services/api';

import { mapGetters } from 'vuex';

const $emails = require('@/assets/emails.json');

export default {
  components: {
    LoadingSpinner,
    EmailTemplate,
  },
  data() {
    return {
      loading: true,
      emailTemplates: $emails,
      distributorTemplates: null,
      distributorEmail: '',
      distributorDomain: '',
      distributor: null,
    };
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  methods: {
    async refresh() {
      this.loading = true;
      const [templates, distributor] = await Promise.all([
        $api.get(
          `/v1/dashboard/emailtemplates/distributor/${this.$route.params.id}`,
        ),
        $api.get(`/v1/dashboard/distributors/${this.$route.params.id}`),
      ]);
      this.distributor = distributor;
      this.distributorEmail = distributor.sender_email;
      this.distributorDomain = distributor.domain_name;
      this.distributorTemplates = templates;
      this.loading = false;
    },
    async saveDistributorEmail() {
      this.loading = true;
      this.distributor.sender_email = this.distributorEmail;
      try {
        await $api.put(
          `/v1/dashboard/distributors/${this.distributor.id}`,
          this.distributor,
        );
      } catch (e) {
        alert(JSON.stringify(e));
      }
      this.loading = false;
    },
    async saveTemplate(template) {
      this.loading = true;
      const finalTemplate = {
        ...template,
        distributor_id: this.distributor.id,
      };
      try {
        await $api.put('/v1/dashboard/emailtemplates', finalTemplate);
        const newTemplates = [finalTemplate];
        this.distributorTemplates.forEach((dt) => {
          if (
            dt.language !== finalTemplate.language ||
            dt.type !== finalTemplate.type
          ) {
            newTemplates.push(dt);
          }
        });
        this.distributorTemplates = newTemplates;
      } catch (e) {
        alert(JSON.stringify(e));
      }
      this.loading = false;
    },
  },
  created() {
    this.refresh();
  },
};
</script>
